/**
 * RequestConstants.ts
 */
export class RequestConstants {
}
/* Method types */
RequestConstants.GET = "GET";
RequestConstants.POST = "POST";
RequestConstants.PUT = "PUT";
/* Authorisation Types */
RequestConstants.HEADER = "HEADER";
RequestConstants.BODY = "BODY";
/* Content Types */
RequestConstants.APPLICATION_JSON = "application/json";
RequestConstants.APPLICATION_XML = "application/xml";
RequestConstants.TEXT_PLAIN = "text/plain";
RequestConstants.TEXT_XML = "text/xml";
/* Response Types */
RequestConstants.JSON = "json";
RequestConstants.TEXT = "text";
RequestConstants.BLOB = "blob";
RequestConstants.DOCUMENT = "document";
RequestConstants.ARRAY_BUFFER = "arraybuffer";
//# sourceMappingURL=RequestConstants.js.map